var map = {
	"./Tamilnadu-Assembly-NEW.svg": 179,
	"./action.svg": 208,
	"./adventure.svg": 209,
	"./advertorial.svg": 210,
	"./ai.svg": 211,
	"./album.svg": 212,
	"./analysis.svg": 213,
	"./anchor.svg": 214,
	"./android-block.svg": 215,
	"./android-small.svg": 216,
	"./android.svg": 217,
	"./angle-down.svg": 218,
	"./angle-left.svg": 219,
	"./angle-right.svg": 220,
	"./angle-up.svg": 221,
	"./aquarius.svg": 222,
	"./arcade.svg": 223,
	"./aries.svg": 224,
	"./arrow-down.svg": 225,
	"./arrow-left.svg": 226,
	"./arrow-right.svg": 227,
	"./arrow-up.svg": 228,
	"./arrow.svg": 229,
	"./art-director.svg": 230,
	"./astrology.svg": 231,
	"./author-avator.svg": 232,
	"./author.svg": 233,
	"./authoranchor.svg": 234,
	"./authorwhite.svg": 235,
	"./automobile.svg": 236,
	"./backward.svg": 237,
	"./bookmark.svg": 238,
	"./books-vikatan.svg": 239,
	"./brandconnect.svg": 240,
	"./breaking-news.svg": 241,
	"./bullet-arrow.svg": 242,
	"./bundle.svg": 243,
	"./business.svg": 244,
	"./calendar.svg": 245,
	"./cancel.svg": 246,
	"./cancer.svg": 247,
	"./canvas.svg": 248,
	"./capricorn.svg": 249,
	"./cartoonist.svg": 250,
	"./cinema.svg": 251,
	"./clapboard.svg": 252,
	"./clipboard.svg": 253,
	"./close.svg": 254,
	"./comment.svg": 255,
	"./corona-updates-icon.svg": 256,
	"./creative-director.svg": 257,
	"./cricket.svg": 258,
	"./crime.svg": 259,
	"./data.svg": 260,
	"./designed.svg": 261,
	"./double-arrow.svg": 262,
	"./downarrow.svg": 263,
	"./download.svg": 264,
	"./edit.svg": 265,
	"./edited-by.svg": 266,
	"./email.svg": 267,
	"./environment.svg": 268,
	"./exclusivedeals.svg": 269,
	"./facebook-bg.svg": 270,
	"./facebook-icon.svg": 271,
	"./facebook.svg": 272,
	"./filter-icon.svg": 273,
	"./filter.svg": 274,
	"./food-stylist.svg": 275,
	"./forward.svg": 276,
	"./gallery.svg": 277,
	"./game-shop.svg": 278,
	"./gemini.svg": 279,
	"./group.svg": 280,
	"./gzhome.svg": 281,
	"./gzsports.svg": 282,
	"./gztrending.svg": 283,
	"./health.svg": 284,
	"./hexbackground.svg": 285,
	"./home.svg": 286,
	"./humoursatire-entertainment.svg": 287,
	"./icon-apple.svg": 288,
	"./icon-appstore.svg": 289,
	"./icon-audio-app-store.svg": 290,
	"./icon-audio-fb.svg": 291,
	"./icon-audio-instagram.svg": 292,
	"./icon-audio-next.svg": 293,
	"./icon-audio-play-store.svg": 294,
	"./icon-audio-previous.svg": 295,
	"./icon-audio-twitter.svg": 296,
	"./icon-audio-whatsapp.svg": 297,
	"./icon-copy.svg": 298,
	"./icon-episode.svg": 299,
	"./icon-facebook.svg": 300,
	"./icon-google-play.svg": 301,
	"./icon-headset.svg": 302,
	"./icon-home-plus.svg": 303,
	"./icon-login.svg": 304,
	"./icon-open-in-new.svg": 305,
	"./icon-pause.svg": 306,
	"./icon-play.svg": 307,
	"./icon-playstore.svg": 308,
	"./icon-premium.svg": 309,
	"./icon-share.svg": 310,
	"./icon-star.svg": 311,
	"./icon-timer.svg": 312,
	"./icon-twitter.svg": 313,
	"./icon-user.svg": 314,
	"./icon-video.svg": 315,
	"./icon-whatsapp.svg": 316,
	"./illustrator-t1.svg": 317,
	"./illustrator.svg": 318,
	"./infographer.svg": 319,
	"./instagram.svg": 320,
	"./interviews.svg": 321,
	"./ios-block.svg": 322,
	"./ios-small.svg": 323,
	"./ios.svg": 324,
	"./jokes.svg": 325,
	"./leo.svg": 326,
	"./libra.svg": 327,
	"./lifestyle.svg": 328,
	"./line-arrow-next.svg": 329,
	"./line-arrow-prev.svg": 330,
	"./linkedin.svg": 331,
	"./listicle.svg": 332,
	"./live-chat.svg": 333,
	"./liveupdate.svg": 334,
	"./log green.svg": 335,
	"./log grey.svg": 336,
	"./log white.svg": 337,
	"./logic.svg": 338,
	"./login-facebook.svg": 339,
	"./login-google.svg": 340,
	"./login.svg": 341,
	"./logout-mobile.svg": 342,
	"./logout.svg": 343,
	"./longform.svg": 344,
	"./magazines.svg": 345,
	"./mail.svg": 346,
	"./menu-search.svg": 347,
	"./microphone.svg": 348,
	"./minus.svg": 349,
	"./mobile-share.svg": 350,
	"./moderated.svg": 351,
	"./more-outline.svg": 352,
	"./my-vikatan-logo.svg": 353,
	"./mynews.svg": 354,
	"./myvikatanbadge.svg": 355,
	"./narrated.svg": 356,
	"./news.svg": 357,
	"./newsletter.svg": 358,
	"./newslettericon.svg": 359,
	"./olympic.svg": 360,
	"./online-news.svg": 361,
	"./pause.svg": 362,
	"./pdf.svg": 363,
	"./pen.svg": 364,
	"./personalise.svg": 365,
	"./phone.svg": 366,
	"./photo.svg": 367,
	"./photographer.svg": 368,
	"./photostory.svg": 369,
	"./pisces.svg": 370,
	"./play.svg": 371,
	"./plus.svg": 372,
	"./podcast.svg": 373,
	"./podcast_vikatan_menu.svg": 374,
	"./poems.svg": 375,
	"./politics.svg": 376,
	"./premium.svg": 377,
	"./producer.svg": 378,
	"./proofread.svg": 379,
	"./published-by.svg": 380,
	"./published.svg": 381,
	"./rain.svg": 382,
	"./rss.svg": 383,
	"./rupee.svg": 384,
	"./sagitarius.svg": 385,
	"./scorpio.svg": 386,
	"./script-writer.svg": 387,
	"./scripted.svg": 388,
	"./search.svg": 389,
	"./share-alt.svg": 390,
	"./share.svg": 391,
	"./sharechat.svg": 392,
	"./shortform.svg": 393,
	"./shortstories.svg": 394,
	"./shortvideo.svg": 395,
	"./slider-next.svg": 396,
	"./slider-prev.svg": 397,
	"./socialshare.svg": 398,
	"./sort.svg": 399,
	"./sound.svg": 400,
	"./speaker.svg": 401,
	"./speakeraudio.svg": 402,
	"./spiritual.svg": 403,
	"./sponsored.svg": 404,
	"./sports.svg": 405,
	"./star.svg": 406,
	"./stories.svg": 407,
	"./strategy.svg": 408,
	"./stylist.svg": 409,
	"./subscribe-vikatan.svg": 410,
	"./success-icon.svg": 411,
	"./tag.svg": 412,
	"./tamilnadu.svg": 413,
	"./taurus.svg": 414,
	"./technology.svg": 415,
	"./text.svg": 416,
	"./textsms.svg": 417,
	"./thodargal.svg": 418,
	"./thump.svg": 419,
	"./tick.svg": 420,
	"./trending.svg": 421,
	"./twitter-icon.svg": 422,
	"./twitter.svg": 423,
	"./uparrow.svg": 424,
	"./update-black.svg": 425,
	"./user-square.svg": 426,
	"./user.svg": 427,
	"./v-plus-logo.svg": 428,
	"./video-editor.svg": 429,
	"./video-icon.svg": 430,
	"./video-play.svg": 431,
	"./video.svg": 432,
	"./videographer.svg": 433,
	"./vikatan-play-logo-red.svg": 434,
	"./vikatan-play.svg": 435,
	"./vikatan-tv.svg": 436,
	"./vikatan.svg": 437,
	"./vikatanconnect.svg": 438,
	"./vikatanplay.svg": 439,
	"./vikatanspl.svg": 440,
	"./vikatantv.svg": 441,
	"./virgo.svg": 442,
	"./whatsapp-icon.svg": 443,
	"./whatsapp-icon1.svg": 444,
	"./whatsapp.svg": 445,
	"./women-home.svg": 446,
	"./writtenarticles.svg": 447,
	"./writtenstory.svg": 448,
	"./youtube.svg": 449
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 207;